module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiCn.f2ec5f8.ttf";